import { type DeepPartial } from "../types/helpers";
import { type AllResponseTypes, type Locale, type ProgramTheme } from "../types/types";
import { getStore } from "../VerificationService/VerificationServiceStore";
import { createUpdateLocale } from "../VerificationService/VerificationServiceActions";

import { programStore, setPreviewOverrides, clearPreviewOverrides } from "./programStore";
import { setPreviewMessages, clearPreviewMessages } from "./previewMessages";
import { setPreviewMock } from "./previewResponse";

/** Branding edits (themeChoices, customCss, privacyPolicyUrl). */
export function setPreviewBranding(branding: DeepPartial<ProgramTheme>): void {
  setPreviewOverrides({ programTheme: branding });
}

/** Configuration edits (config.*, feature flags). */
export function setPreviewConfiguration(configuration: DeepPartial<ProgramTheme>): void {
  setPreviewOverrides({ programTheme: configuration });
}

/** Merge a partial verification-response override onto the current response. */
export function setPreviewResponse(patch: Partial<AllResponseTypes>): void {
  setPreviewOverrides({ response: patch });
}

/** Switch the previewed locale without teardown (re-fetches messages via the existing action). */
export function setPreviewLocale(locale: Locale): Promise<object> {
  const store = getStore();
  const { programId, verificationResponse } = store.getState();
  return createUpdateLocale(store.dispatch, programId)(locale, verificationResponse?.segment);
}

export function clearPreview(): void {
  // Capture message locales before clearing the store, so we can also drop them from i18next.
  const messageLocales = Object.keys(programStore.get().overrides.messages ?? {}) as Locale[];
  clearPreviewOverrides();
  clearPreviewMessages(messageLocales);
}

export { setPreviewMessages, setPreviewMock };
